"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpectrumProvider = void 0;
var _react = _interopRequireWildcard(require("react"));
var _context = require("./context");
var _useSpectrum = require("./useSpectrum");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const SpectrumProvider = /*#__PURE__*/(0, _react.memo)(({
  value,
  children
}) => {
  const spectrum = (0, _useSpectrum.useSpectrum)();
  return /*#__PURE__*/_react.default.createElement(_context.SpectrumContext.Provider, {
    value: value !== null && value !== void 0 ? value : spectrum
  }, children);
});
exports.SpectrumProvider = SpectrumProvider;
SpectrumProvider.displayName = 'SpectrumProvider';